__turbopack_context__.v({
  "calendarPlaceholder": "calendarSection-module__ct7eCG__calendarPlaceholder",
  "calendarSection": "calendarSection-module__ct7eCG__calendarSection",
  "calenderTitle": "calendarSection-module__ct7eCG__calenderTitle",
});
